import { svg } from "config/svgStyles";

export const imageToolTip = ({ imageWidth = "200px" }) => ({
  color: "white",
  display: "flex",
  flexDirection: "column",
  border: "solid 1px",
  borderColor: "black",
  borderRadius: "8px",
  width: imageWidth,
  overflow: "hidden",
});

export const image = ({
  image,
  imageWidth = "200px",
  imageHeight = "130px",
  backgroundColor = "transparent",
}) => ({
  backgroundImage: `url(${image})`,
  backgroundColor,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "50% 50%",
  height: imageHeight,
  width: imageWidth,
});

export const labelImageContainer = {
  width: "100%",
  marginBottom: "10px",
};

export const labelImageSvg = ({ color }) => ({
  ...svg(color),

  "&> svg": {
    maxWidth: "67%",
    maxHeight: "14px",
  },
});

export const text = ({ hasChildren }) => ({
  width: "100%",
  padding: hasChildren ? "20px" : 0,
});
